var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" "+_vm._s(_vm.$t('MEMBERSHIP_SUCCESS_TITLE'))+" ")]),_c('section',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.content),expression:"content"}]})])}
var staticRenderFns = []

export { render, staticRenderFns }